// ===== Updated Dropdown Menu Toggle Code =====
const menuButtons = document.querySelectorAll('.js-menu-toggle, .top-bar-menu');
const catalogButton = document.querySelector('.catalog-button');
const dropdownMenu = document.querySelector('.dropdown-menu');
const dropdownCatalog = document.querySelector('.dropdown-catalog');
const dropdownContainer = document.querySelector('.dropdown-container');
const linksButton = document.querySelector('.io-nav-links');
const linkRail = document.querySelector('.io-link-rail');

function closeMobileLinks() {
  if (!linksButton || !linkRail) return;

  linksButton.setAttribute('aria-expanded', 'false');
  linkRail.classList.remove('is-open');
}

function openMobileLinks() {
  if (!linksButton || !linkRail) return;

  linksButton.setAttribute('aria-expanded', 'true');
  linkRail.classList.add('is-open');
  dropdownMenu?.classList.remove('click');
  dropdownCatalog?.classList.remove('click');
  dropdownContainer?.classList.remove('click');
}

menuButtons.forEach((menuButton) => {
  menuButton.addEventListener('click', () => {
    if (!dropdownMenu || !dropdownContainer) return;
    closeMobileLinks();
    dropdownMenu.classList.toggle('click');
    dropdownContainer.classList.toggle('click'); // Toggling the dropdown-container

    // Close catalog dropdown (and container highlight) when closing main menu
    if (!dropdownMenu.classList.contains('click')) {
      dropdownCatalog?.classList.remove('click');
      dropdownContainer.classList.remove('click'); // Ensure container is reset
    }
  });
});

linksButton?.addEventListener('click', (event) => {
  event.preventDefault();

  if (linksButton.getAttribute('aria-expanded') === 'true') {
    closeMobileLinks();
  } else {
    openMobileLinks();
  }
});

linkRail?.addEventListener('click', (event) => {
  if (event.target.closest('a')) closeMobileLinks();
});

catalogButton?.addEventListener('click', (e) => {
  e.preventDefault(); // Prevent default link behavior
  // Only toggle catalog if main menu is open
  if (dropdownMenu?.classList.contains('click')) {
    dropdownCatalog?.classList.toggle('click');
  }
});

// Close all menus when clicking outside
document.addEventListener('click', (e) => {
  if (
    !e.target.closest('.js-menu-toggle') &&
    !e.target.closest('.top-bar-menu') &&
    !e.target.closest('.dropdown-menu') &&
    !e.target.closest('.dropdown-container') &&
    !e.target.closest('.dropdown-catalog')
  ) {
    dropdownMenu?.classList.remove('click');
    dropdownCatalog?.classList.remove('click');
    dropdownContainer?.classList.remove('click'); // Remove click class from container
  }

  if (
    !e.target.closest('.io-nav-links') &&
    !e.target.closest('.io-link-rail')
  ) {
    closeMobileLinks();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  closeMobileLinks();
});

const topBarHoverImages = Array.from(document.querySelectorAll(
  '.top-bar-menu img[data-alt], .top-bar-cart img[data-alt], .top-bar-logo img[data-alt], .top-bar-your-cart img[data-alt], .top-bar-continue img[data-alt]'
));

topBarHoverImages.forEach((img) => {
  if (!img.dataset.alt || !img.parentElement || img.dataset.ioHoverSwapBound === 'true') return;
  img.dataset.ioHoverSwapBound = 'true';

  const originalSrc = img.currentSrc || img.src;
  const altSrc = img.dataset.alt;
  const swapIn = () => { img.src = altSrc; };
  const swapOut = () => { img.src = originalSrc; };

  img.parentElement.addEventListener('mouseenter', swapIn);
  img.parentElement.addEventListener('mouseleave', swapOut);
  img.parentElement.addEventListener('touchstart', swapIn, { passive: true });
  img.parentElement.addEventListener('touchend', swapOut, { passive: true });
  img.parentElement.addEventListener('touchcancel', swapOut, { passive: true });
});


// First container code - Regular review media
const wrapper = document.querySelector('.review-cards-wrapper:not(.wrapper2)');

if (wrapper) {
  document.querySelectorAll('.slider-button:not(.wrapper2)').forEach(button => {
    button.addEventListener('click', () => {
      const direction = button.getAttribute('data-direction');
      // Get all direct child cards of the first wrapper
      const cards = Array.from(wrapper.children);
      const wrapperRect = wrapper.getBoundingClientRect();
      const currentScroll = wrapper.scrollLeft;

      if (direction === 'right') {
        // Find the first card to the right of the wrapper's left edge
        const nextCard = cards.find(card => {
          const cardRect = card.getBoundingClientRect();
          return cardRect.left > wrapperRect.left + 1; // slight tolerance
        });
        if (nextCard) {
          const cardRect = nextCard.getBoundingClientRect();
          const scrollTo = currentScroll + (cardRect.left - wrapperRect.left);
          wrapper.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
      } else {
        // For scrolling left, reverse the cards array
        const reversedCards = cards.slice().reverse();
        const prevCard = reversedCards.find(card => {
          const cardRect = card.getBoundingClientRect();
          return cardRect.left < wrapperRect.left - 1; // slight tolerance
        });
        if (prevCard) {
          const cardRect = prevCard.getBoundingClientRect();
          const scrollTo = currentScroll + (cardRect.left - wrapperRect.left);
          wrapper.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
      }
    });
  });
}

// Second container code - iPhone media scroller
const wrapper2 = document.querySelector('.review-cards-wrapper.wrapper2');

if (wrapper2) {
  document.querySelectorAll('.slider-button.wrapper2').forEach(button => {
    button.addEventListener('click', () => {
      const direction = button.getAttribute('data-direction');
      // Get all direct child cards of wrapper2
      const cards = Array.from(wrapper2.children);
      const wrapperRect = wrapper2.getBoundingClientRect();
      const currentScroll = wrapper2.scrollLeft;

      if (direction === 'right') {
        // Find the first card to the right of wrapper2's left edge
        const nextCard = cards.find(card => {
          const cardRect = card.getBoundingClientRect();
          return cardRect.left > wrapperRect.left + 1; // slight tolerance
        });
        if (nextCard) {
          const cardRect = nextCard.getBoundingClientRect();
          const scrollTo = currentScroll + (cardRect.left - wrapperRect.left);
          wrapper2.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
      } else {
        // For scrolling left, check the cards in reverse order
        const reversedCards = cards.slice().reverse();
        const prevCard = reversedCards.find(card => {
          const cardRect = card.getBoundingClientRect();
          return cardRect.left < wrapperRect.left - 1; // slight tolerance
        });
        if (prevCard) {
          const cardRect = prevCard.getBoundingClientRect();
          const scrollTo = currentScroll + (cardRect.left - wrapperRect.left);
          wrapper2.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
      }
    });
  });
}


document.addEventListener('DOMContentLoaded', function() {
  // Force immediate load of the first slide
  const lazyImages = document.querySelectorAll('.swiper-lazy');
  if (lazyImages.length > 0) {
    lazyImages[0].classList.remove('swiper-lazy');
    lazyImages[0].setAttribute('loading', 'eager');
  }
  
  // Find the XO Slider container
  const swiperContainer = document.querySelector('.swiper-container');
  if (swiperContainer) {
    // Tell browser this is important
    swiperContainer.setAttribute('fetchpriority', 'high');
  }
  
  const preloadImages = () => {
    const scheduled = new Set();

    topBarHoverImages.forEach((img) => {
      const href = img.dataset.alt;
      const alreadyPreloaded = Array.from(document.querySelectorAll('link[rel="preload"][as="image"]'))
        .some((link) => link.getAttribute('href') === href || link.href === href);

      if (!href || scheduled.has(href) || alreadyPreloaded) return;
      scheduled.add(href);

      const preloadLink = document.createElement('link');
      preloadLink.rel = 'preload';
      preloadLink.as = 'image';
      preloadLink.href = href;
      preloadLink.dataset.ioPreload = 'hover-alt';
      document.head.appendChild(preloadLink);
    });
  };

  const schedulePreload = () => {
    if (!topBarHoverImages.length) return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadImages, { timeout: 1800 });
    } else {
      window.setTimeout(preloadImages, 600);
    }
  };
  
  if (document.readyState === 'complete') {
    schedulePreload();
  } else {
    window.addEventListener('load', schedulePreload, { once: true });
  }
});

function handleImageLoading() {
  const productImages = document.querySelectorAll('.product-image');
  
  productImages.forEach(img => {
    // Start with blur effect
    img.style.filter = 'blur(10px)';
    img.style.transition = 'filter 0.5s ease-out';
    
    img.onload = () => {
      // Smoothly remove blur when loaded
      img.style.filter = 'blur(0)';
    };
  });
}
